module.exports = __webpack_public_path__ + "img/password-dark.d0458863.svg";